import React from 'react'

import cx from 'classnames'
import { useTranslations } from 'next-intl'
import Image from 'next/legacy/image'
import Link from 'next/link'

import { useGameImages } from '@/components/games/images'
import { useGames } from '@/features/common/useGames'
import { Game, GAME_STATUS } from '@/fixtures/games'

import styles from './GameSelector.module.scss'

const GameButton = ({ game }: { game: Game }) => {
  const { gameImage } = useGameImages(game.slug)
  const t = useTranslations()
  return (
    <div className={cx(styles.GameButtonContainer, { [styles.ComingSoon]: game.status === GAME_STATUS.COMING_SOON })}>
      {game.status === GAME_STATUS.COMING_SOON && <div className={styles.Label}>{t('lan_coming_soon')}</div>}
      <Link
        href={`/game/${game.slug}`}
        className={cx(styles.GameLogoContainer, { [styles.DisabledLink]: game.status === GAME_STATUS.COMING_SOON })}
        data-cy={`gameselector-${game.slug}`}
      >
        <div className={styles.GameLogo}>
          <Image
            alt={game.slug + 'logo'}
            src={gameImage('logo')}
            layout="fill"
            objectFit="contain"
            priority
            placeholder="blur"
            sizes="(max-width: 600px) 50vw, 30vw"
            quality="100"
          />
        </div>
      </Link>
    </div>
  )
}

export const GameSelector = () => {
  const games = useGames()
  return (
    <div className={styles.Container}>
      {games.map((game) => {
        return <GameButton key={game.shortSlug} game={game} />
      })}
    </div>
  )
}
